/* TRIGGERS */

$(document).ready(function() {
  updatePrice();
});

$('.build-set-container .build-set__item input[name="field-initials"]').change(function() {
  var selectedValue = $(this).val();
  updateInitialsDropdown(selectedValue);
});

$('.build-set-container .build-set__item input').change(function() {
  updatePrice();
});

$('.build-set__variants--dropdown--select').on('change', function() {
  updatePrice();
});

$('#container-buttons button.custom-ab-test-byn__button--add-to-cart').click(function() {
  addToCartTrigger();
});


$('#container-buttons button.custom-ab-test-byn__button-complete-your-purchase').click(function() {
  completeYourPurchaseTrigger();
});


/* FUNCTIONS */

function updateInitialsDropdown(x){
  $('.build-set__variants--dropdown .build-set__variants--dropdown__items').removeClass('initials-item--active');
  let iterations = parseInt(x);
  for (var i = 1; i <= iterations; i++) {
    $('.build-set__variants--dropdown .build-set__variants--dropdown__items[data-select="'+ i +'"]').addClass('initials-item--active');
  } 
};

function updatePrice(){
  let total = 0;
  let compareAtPrice = 0;
  $('.build-set-container .build-set__item').each(function(){
    let radio = $(this).find('.build-set__variants--radio');
    let dropdown = $(this).find('.build-set__variants--dropdown');
    let header = $(this).find('.build-set__header .price');
    let headerCompare = $(this).find('.build-set__header .compare-at-price');

    if(radio.length){
      let price = $(radio).find('input:checked').attr('data-price');
      let compare = $(radio).find('input:checked').attr('data-compare-price');
      
      if(price){
        price = parseFloat(price) / 100;
        $(header).text(price.toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(header).attr('data-price',price);
      } else {
        price = 0;
        $(header).text(price.toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(header).attr('data-price',price);
      }

      if(compare){
        compare = parseFloat(compare) / 100;
        $(headerCompare).text(compare.toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(headerCompare).attr('data-compare',compare);
      } else {
        compare = 0;
        $(headerCompare).text(compare.toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(headerCompare).attr('data-compare',compare);
      }
      
      total += price;
      compareAtPrice += compare;
    }
    
    if(dropdown.length){
      let selectsEvent = $(this).find('.build-set__variants--dropdown__items.initials-item--active');
      let priceSelect = 0;
      let compareSelect = 0;
      $(selectsEvent).each(function(){
        
        let price = parseFloat($(this).find('select option:selected').attr('data-price'));
        $(this).find('label b').text((price/100).toLocaleString("en-US", {style: "currency", currency: "USD"}));

        let compare = parseFloat($(this).find('select option:selected').attr('data-compare-price')) || 0;
        $(this).find('label i').text((compare / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));

        priceSelect += price;
        compareSelect += compare;
      });
      
      priceSelect = priceSelect / 100;
      $('#price-initial-global').text(priceSelect.toLocaleString("en-US", {style: "currency", currency: "USD"})); 

      compareSelect = compareSelect / 100;
      $('#compare-at-price-initial-global').text(compareSelect.toLocaleString("en-US", {style: "currency", currency: "USD"})); 

      total += priceSelect;
      compareAtPrice += compareSelect;
    }
  });
  $('.product-block.product-block--price .product__price').text(total.toLocaleString("en-US", {style: "currency", currency: "USD"}));
  $('.product-block.product-block--price .product__price.on-sale').text(compareAtPrice.toLocaleString("en-US", {style: "currency", currency: "USD"}));

  $('.prices-container--campaign--set-discount .prices-container--campaign__offer').text(total.toLocaleString("en-US", {style: "currency", currency: "USD"}));
  $('.prices-container--campaign--set-discount .prices-container--campaign__regular').text(compareAtPrice.toLocaleString("en-US", {style: "currency", currency: "USD"}));
  
  $('#total-necklace p b').text(total.toLocaleString("en-US", {style: "currency", currency: "USD"}));
  $('#total-necklace p i').text(compareAtPrice.toLocaleString("en-US", {style: "currency", currency: "USD"}));
};


function addToCartTrigger(){
  let $button = $('#container-buttons button.custom-ab-test-byn__button--add-to-cart');
  $button.addClass('btn--loading');
  var skuSet = $skuSet();
  var productosData = [];

  $('.build-set-container .build-set__item').each(function(){
    let radio = $(this).find('.build-set__variants--radio');
    let dropdown = $(this).find('.build-set__variants--dropdown');

    if(radio.length){
      let idVariant = $(radio).not('.build-set__variants--initials').find('input:checked').val();
      if (idVariant !== undefined && idVariant !== 'offer_not_include'){
        var objeto = {
          id: idVariant,
          quantity: 1,
          properties: {
            'ID SET': skuSet,
            'CHAIN': 'Included'
          }
        };
        productosData.push(objeto);
      }
    }
    
    if(dropdown.length){
      let selectsEvent = $(this).find('.build-set__variants--dropdown__items.initials-item--active');
      $(selectsEvent).each(function(){
        let idVariant = $(this).find('select option:selected').val();
        let initialTitle = $(this).find('label > span').text();
        console.log(initialTitle);
        let initial = $(this).find('select option:selected').attr('data-initial');
        var objeto = {
          id: idVariant,
          quantity: 1,
          properties: {
            'ID SET': skuSet,
            [initialTitle]: initial
          }
        };
        productosData.push(objeto);
      });
    }
    
  })

  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: productosData
      },
      dataType: 'json',
      success: function() {
        $button.removeClass('btn--loading');
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        $button.removeClass('btn--loading');
      }
  });
};

function completeYourPurchaseTrigger(){
  let $button = $('#container-buttons button.custom-ab-test-byn__button-complete-your-purchase');
  $button.addClass('btn--loading');
  var skuSet = $skuSet();
  var productosData = [];

  const SmartCart = window.Rebuy.SmartCart;
  SmartCart.destroy();
  console.log('SmartCart.destroy();');

  $('.build-set-container .build-set__item').each(function(){
    let radio = $(this).find('.build-set__variants--radio');
    let dropdown = $(this).find('.build-set__variants--dropdown');

    if(radio.length){
      let idVariant = $(radio).not('.build-set__variants--initials').find('input:checked').val();
      if (idVariant !== undefined && idVariant !== 'offer_not_include'){
        var objeto = {
          id: idVariant,
          quantity: 1,
          properties: {
            'ID SET': skuSet,
            'CHAIN': 'Included'
          }
        };
        productosData.push(objeto);
      }
    }
    
    if(dropdown.length){
      let selectsEvent = $(this).find('.build-set__variants--dropdown__items.initials-item--active');
      $(selectsEvent).each(function(){
        let idVariant = $(this).find('select option:selected').val();
        let initialTitle = $(this).find('label > span').text();
        console.log(initialTitle);
        let initial = $(this).find('select option:selected').attr('data-initial');
        var objeto = {
          id: idVariant,
          quantity: 1,
          properties: {
            'ID SET': skuSet,
            [initialTitle]: initial
          }
        };
        productosData.push(objeto);
      });
    }
    
  })

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: productosData
    },
    dataType: 'json',
    success: function() {
      /*$button.removeClass('btn--loading');*/
      window.location.href = '/checkout';
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      $button.removeClass('btn--loading');
      console.error('Error al agregar productos al carrito:', errorThrown);
    }
  });

};

function $skuSet(){
  var letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var numeros = '0123456789';
  var resultado = '';
  for (var i = 0; i < 2; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
  }
  for (var i = 0; i < 3; i++) {
      resultado += numeros.charAt(Math.floor(Math.random() * numeros.length));
  }
  resultado = resultado.split('').sort(function() { return 0.5 - Math.random() }).join('');
  return resultado;
};